<div class="status-help-dialog__header">
  <h2 mat-dialog-title class="status-help__header__title">Status Help</h2>
  <button matIconButton mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  @for (status of statusInfo; track status) {
    <div class="status-help-dialog__status">
      <h3 class="status-help-dialog__status__name">{{ status.name }}</h3>
      <p class="status-help-dialog__status__info" [innerHtml]="status.info"></p>
    </div>
  }
</mat-dialog-content>
